<template>
  <div>
    <label class="text-uppercase text-muted font-weight-bold small">JS Tag Integration Code</label>
    <b-alert show>
      Paste the below code snippet where the ad unit should be displayed
    </b-alert>
    <code>
      <b-form-textarea
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        readonly
        class="squared-textarea bg-white" rows="15"
        :value="integrationCode">
      </b-form-textarea>
    </code>
  </div>
</template>

<script>
  export default {
      name: 'IntegrationPrebidJs',
      props: {
          zone: { required: true, type: Object }
      },
      computed: {
          integrationCode () {
            return '<script id="' + this.zone.id + '">\n' +
              '  (function () {\n' +
              '    var smrtb = {\n' +
              '      endpoint: "' + this.endpoint + '",\n' +
              '      pubId: "' + this.zone.company_id + '",\n' +
              '      medId: "' + this.zone.med_id + '",\n' +
              '      zoneId: "' + this.zone.id + '",\n' +
              '      cpv: false\n' +
              '    }\n' +
              '\n' +
              '    var script = document.createElement("script");\n' +
              '    script.src = "//ads.smrtb.com/tag.js"\n' +
              '    script.onload = function () { new SmartTag(smrtb).setup().start(); };\n' +
              '    document.body.appendChild(script);\n' +
              '  })();\n' +
              '</\script>';
          },
          endpoint () {
            let ep = ENDPOINT_GLOBAL_SSL
            if (ep.startsWith("http")) {
              ep = ep.split(":")[1]
            }
            if (ep.charAt(ep.size - 1) !== '/') {
              ep += '/'
            }

            return ep + '/json/publisher/js'
        }
      }
  }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/Integrations/JSTag.vue